/**
 * AdoraCare -- the PATIENT / TABLET intake-mode route guard
 * (PATIENT-INTAKE-PREFILL-AND-EXPERIENCE-V1, Section 8). Renders the bounded
 * full-screen patient surface ONLY for an authenticated session (the
 * receptionist's own session -- no new auth, no public token, no QR). It sits
 * at a top-level route OUTSIDE AppLayout/DashboardLayout, so no staff header or
 * nav can render around it; an unauthenticated hit bounces to /login rather
 * than exposing any surface. The backend route stays the security boundary
 * (creation-authority + org/clinic fences on every intake call).
 */

import { Navigate } from 'react-router-dom';

import { useAuth } from '@/auth/auth-context';
import PatientIntakeMode from './PatientIntakeMode';

export default function RequirePatientIntakeMode(): JSX.Element {
  const { user, loading, authConfigured } = useAuth();
  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Loading...
      </div>
    );
  }
  if (authConfigured && !user) {
    return <Navigate to="/login" replace />;
  }
  return <PatientIntakeMode />;
}
